import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$Banner } from '@otovo/shared/types/sanityTypes';
import { PortableText } from '@portabletext/react';
import { useRouter } from 'next/router';
import { routeToHref } from '../../SanityLandingPage/routeToHrefUtil';
import CTALink from '../CTALink';

type BannerProps = {
  banner: Sanity$Banner;
};

const Banner = ({ banner }: BannerProps) => {
  const { cta, content } = banner;
  const config = useGlobalConfig();
  const { locale } = useRouter() as { locale: Otovo$Locale };

  return (
    <div className="color-scheme-dark absolute top-20 isolate z-50 flex w-full flex-col bg-black/30 px-4 py-3 sm:flex-row sm:items-center sm:justify-center sm:gap-2 sm:px-6 sm:py-4">
      <PortableText
        value={content}
        components={{
          block: ({ children }) => (
            <span className="text-base text-white">{children}</span>
          ),
        }}
      />
      {cta && (
        <CTALink
          className="underline underline-offset-4 hover:!no-underline"
          href={routeToHref(cta.route, config.BU_CONFIG.market, locale)}
        >
          {cta.title}
        </CTALink>
      )}
    </div>
  );
};
export default Banner;
